export const projectsData = [
    {
        id: 1,
        projectName: 'La caféine',
        projectDesc: 'Séquence vidéo expliquant les effets de la caféine sur le corps humain',
        tags: [],
        code : '',
        demo: 'https://www.facebook.com/reel/1158661215033187',
        image: '/images/café.png'
    },
    {
        id: 2,
        projectName: 'Le sommeil',
        projectDesc: 'Pourquoi dort-on la nuit? Vous ne tarderez pas à connaîntre la réponse en cliquant sur le bouton en dessous.',
        tags: [],
        code : '',
        demo: 'https://www.facebook.com/reel/472386948090093',
        image: '/images/sommeil.png'
    },
    {
        id: 3,
        projectName: 'Le sucre',
        projectDesc: "Quelle est la quantité de sucre idéale qu'il faudrait consommer au quotidien? Cliquez sur le bouton en dessous pour connaître la réponse.",
        tags: [],
        code : '',
        demo: 'https://www.facebook.com/reel/1284949302274360',
        image: '/images/sucre.png'
    },
    {
        id: 4,
        projectName: 'Le manque de sommeil chez les enfants',
        projectDesc: 'Quels sont les dangers du manque de sommeil chez les enfants? Comment y remédier?',
        tags: [],
        code : '',
        demo: 'https://www.facebook.com/reel/456854662902149',
        image: '/images/manquedesommeil.png'
    },
    {
        id: 5,
        projectName: 'Les poux',
        projectDesc: "Comment se protéger des poux ? Regardez la vidéo en cliquant sur le bouton en dessous pour plus d'informations !",
        tags: [],
        code : '',
        demo: 'https://www.facebook.com/reel/6400545926628291',
        image: '/images/poux.png'
    },
    {
        id: 6,
        projectName: 'Les protéines',
        projectDesc: "Pourquoi les protéines sont-elles une obligation dans la vie de l'être humain ? Regardez la séquence vidéo pour en savoir plus !",
        tags: [],
        code : '',
        demo: 'https://www.facebook.com/reel/507092754720138',
        image: '/images/proteines.png'
    },
    {
        id: 7,
        projectName: 'Les maladies rénales et le jeûne',
        projectDesc: 'Explication concernant les différents types de maladies rénales et leur impact sur le jeûne.',
        tags: [],
        code : '',
        demo: 'https://www.facebook.com/reel/728788515645211',
        image: '/images/rein.png'
    },
    {
        id: 8,
        projectName: 'Le tabac',
        projectDesc: 'Cette séquence vidéo met en relief Les effets nocifs du tabac. Mais aussi, elle offre quelques conseils sur la démarche à adopter pour arrêter de fumer.',
        tags: [],
        code : '',
        demo: 'https://www.facebook.com/dr.feten.Taktak/videos/781157276947492',
        image: '/images/cigarette.png'
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/